import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { AgeSelectMenuComponent } from './age-select-menu.component';

@NgModule({
	declarations: [AgeSelectMenuComponent],
	imports: [
		CommonModule,
		FormsModule,
	],
	exports: [AgeSelectMenuComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AgeSelectMenuModule { }
